import axiosInstance from "./axiosInstance";
import { createAsyncThunk } from "@reduxjs/toolkit";


export const registerUser = createAsyncThunk(
  "auth/register",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/register", data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response.data.errors || [error.response.data.error]
      );
    }
  }
);
export const loginUser = createAsyncThunk(
  "auth/login",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/login", data);
      if (response.status === 401) {
        console.log("response service", response.response.data.message);
        return rejectWithValue([response.response.data.message]);
      }
      const token = response.data.token;
      if (token) {
        localStorage.setItem("token", token);
      }
      return response.data;
    } catch (error) {
      return rejectWithValue([error.response.data.message]);
    }
  }
);

